import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        //活动日期
        versTime: '3月10日——3月16日',
        //首页赏金任务文字
        taskText: '赏金猎人限时任务：每天前2次通关史前战争-巨龙之谷困难或困难以上难度，可获得额外的犒赏！',
        // taskText2: '无限次元地图更换为：地牢围攻、古墓憟影、亡魂古镇、法老亡陵',
        //靶场模块数据及时间
        bcData: {
            Date: "3月10日—3月16日",
            rangeList: [
                "传承-大地撕裂者 Mk.6概率翻倍",
                "毒液之牙碎片",
                "体质增强器II型（永久）",
                "静音装置（永久）"
            ]
        },
        //军需补给箱模块数据及时间
        jxData: {
            Date: "2020年3月3日—2020年3月16日",
            jxList: ['歼星巨龙时空箱（稀有）', '泰山Sako M90', '泰山Sako M90专属材料']
        },

        //免费福利模块数据
        freePropsData: {
            pageDate: "3月3日——3月16日",
            allPeople: [
                // 'AUG', '破军HK21', '毛瑟M1932', '精钢Hawker-1', '破军-守备官', '静音装置'
                // 'USP', '破军AN94', '魔煞UMP9', '精钢QBU88', '毛瑟M1932', '力量增幅器'
                'M249_SAW', '退魔AA12', '军灵AWP', '精钢AK47', '精钢FN57', '移动装置'
            ],
            vip: ['高碳怒焰风暴', '钛钢UMP9', '破军光束剑']
            // vip: ['高碳QBS09', '钛钢HK21', '高碳M29']
            // vip: ['高碳QBS09', '钛钢HK416', '钛钢毛瑟M1932']

        },
        // saleTime 为saleTIme 模块的数据 
        // saleTime1: {
        //     num: "01",
        //     saleDate: "1月21日维护后——2月4日维护前",
        //     title: "永恒VIP帝王礼包",
        //     saleWay: "限时销售",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买<span style="color:red">永恒VIP帝王礼包</span>。`,
        //         `打开永恒VIP帝王包，可获得：永恒VIP帝王名片（专属）、永恒VIP帝王专属时装（永恒骑士（男）/永恒魔铃（女））、暴君-原始咆哮（7天）x1、暴君-熔岩爆裂（7天）x1、暴君-末日审判（7天）x1、战灵KS-23战术材料x5、传承AUGA2专属材料x5、冻结者专属材料x5、毁灭者专属材料x5、传承MP5专属材料x5、传承核心x30、ID识别卡x30、能量棒x100、逃跑清除卡x30、经验五倍卡x30、金币五倍卡x30、材料五倍卡x30。`,
        //     ],
        //     span: []
        // },
        // saleTime2: {
        //     num: "02",
        //     saleDate: "1月21日维护后——2月4日维护前",
        //     title: "变身装置升阶材料",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买<span style="color:red">还魂天姬专属材料以小搏大包、魅鬼专属材料以小搏大包、爆尸犬专属材料以小搏大包、生化系通用材料以小搏大包，暴怒盾战专属材料以小搏大包、狙击手专属材料以小搏大包、霰弹前锋专属材料以小搏大包、武装步兵专属材料以小搏大包、侦察兵专属材料以小搏大包、改造系通用材料以小搏大包，</span>助你轻松升级你的变身装置。`,
        //     ],
        //     span: []
        // },
        // saleTime1: {
        //     num: "01",
        //     saleDate: "5月28日维护后——6月10日维护前",
        //     title: "儿童节限定武器升阶材料",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买<span style="color:red">玩具零件、神器碎片特惠礼包，</span>助你轻松升级你的<span style="color:red">橙级玩具机枪、橙级玩具枪</span>。`,
        //     ],
        //     span: []
        // },
        // saleTime2: {
        //     num: "02",
        //     saleDate: "5月28日维护后——6月10日维护前",
        //     title: "宝宝熊/宝宝兔以小搏大包",
        //     saleWay: "限时销售",
        //     p: [
        //         `1、 活动期间玩家可在游戏内商城购买到<span style="color:red">“宝宝熊/宝宝兔以小搏大包”，</span>开启后可随机获得永久、30天、7天、3天期限的宝宝熊/宝宝兔一件（至少可获得3天期限）。以小博大，愿你永久梦想！`,
        //         `2、 充满了童趣的绒毛玩偶服，不但能唤醒你对纯真的向往，还能雷到你的对手！`,
        //     ],
        //     span: []
        // },
        // saleTime1: {
        //     num: "01",
        //     saleDate: "9月3日维护后——9月17日维护前",
        //     title: "亡魂颂歌预售券",
        //     saleWay: "限时销售",
        //     p: [
        //         `活动期间玩家可以在游戏内商城内购买<span style="color:red">“亡魂颂歌预售券”、“亡魂颂歌升级材料预售券”</span>；`,
        //         `<span style="color:red">亡魂颂歌（初心者）预售券：</span>购买该预售券后，可在次日以邮件的形式收到“预售伴手礼”礼包一个，9月24日维护后，可以点击“使用”按钮，并获得“亡魂颂歌-无常”一把（最高可升级至暴君-亡魂颂歌）。（该道具仅能购买一次）`,
        //         `<span style="color:red">亡魂颂歌（进化者）升级材料预售券：</span>购买该预售券后，9月24日维护后，可点击“使用”按钮，并获得亡魂颂歌升级材料一套，助您升级至“亡魂颂歌-夜叉”。（该道具仅能购买一次）`,
        //     ],
        //     span: []
        // },
        saleTime1: {
            num: "01",
            saleDate: "3月10日维护后——3月17日维护前",
            title: "地狱猎人以小搏大包",
            saleWay: "限时销售",
            p: [
                `1、 活动期间玩家可在游戏内商城购买到<span style="color:red">“地狱猎人以小搏大包（男/女）”，</span>开启后可随机获得永久、30天、7天、3天期限的地狱猎人(男/女)一套（至少可获得3天期限）。以小博大，愿你永久梦想！`,
                `2、 “地狱猎人”时装属性：PVE模式中提高生命上限15%。`,
                `　　如果你赞颂光明，那么也请你拥抱黑夜，如果你看到面前的阴影,别怕,那是因为你的背后有阳光。`,
                `　　“Hellhunter”`,
                `　　“PVE模式中提高生命上限15%”`,
            ],
            span: []
        },
        // saleTime3: {
        //     num: "03",
        //     saleDate: "12月3日维护后——12月10日维护前",
        //     title: "稀有挂件",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买到<span style="color:red">“龙腾涂装弹匣（传承MP5专属）以小搏大包、龙腾涂装弹匣（传承AUGA2）以小搏大包、龙腾涂装弹匣（传承M1100专属）以小搏大包”</span>打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">龙腾涂装弹匣</span>（至少可获得3天期限）。以小博大，愿你永久梦想！`,
        //     ],
        //     span: []
        // },
        // saleTime1: {
        //     num: "01",
        //     saleDate: "2月18日维护后——3月3日维护前",
        //     title: "君临天下大礼包",
        //     saleWay: "限时销售",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买<span style="color:red;">“君临天下大礼包”</span>，打开即可获得：<span style="color:red;">暴君-稳定芯片，暴君武器幸运包（7天）</span>；`,
        //         `<span style="color:red;">暴君-稳定芯片</span>：`,
        //         `结合史前神秘云石制作的暴君武器专用挂件，可提高瞄准状态下的射击稳定。`,
        //         `“暴君武器专用”`,
        //         `“加装芯片后将自动与武器绑定，当武器到期后将自动卸载”`,
        //     ],
        //     span: []
        // },
        // saleTime2: {
        //     num: "02",
        //     saleDate: "2月18日维护后——3月3日维护前",
        //     title: "辉煌暴君大礼包",
        //     saleWay: "限时销售",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买<span style="color:red;">“辉煌暴君大礼包”</span>，打开即可获得：<span style="color:red;">暴君-精准芯片，暴君武器幸运包（7天）</span>；`,
        //         `<span style="color:red;">暴君-精准芯片</span>：`,
        //         `结合史前神秘云石制作的暴君武器专用挂件，能够增加瞄准射击精度。`,
        //         `“暴君武器专用”`,
        //         `“加装芯片后将自动与武器绑定，当武器到期后将自动卸载”`,
        //     ],
        //     span: []
        // },
        // saleTime3: {
        //     num: "03",
        //     saleDate: "2月18日维护后——3月3日维护前",
        //     title: "ID识别卡",
        //     saleWay: "限时特卖",
        //     p: [
        //         `1、活动期间玩家可以在游戏内商城以<span style="color:red;">原价8.5折的优惠购买ID识别卡（50）特惠包，礼包内含：“ID识别卡x50+军需补给箱x50”；</span>`,
        //         `2、活动期间玩家可以在游戏内商城以<span style="color:red;">原价7.5折的优惠购买ID识别卡（100）特惠包，礼包内含“ID识别卡x100+军需补给箱x100”；</span>`,
        //         `使用ID识别卡可开启军需补给箱，开启补给箱100%获奖，所有奖品都为点券商品。除了数十种永久武器装备外，更有机会获得游戏中从未出售过的极品非卖商品。`,
        //     ],
        //     span: []
        // },
        // saleTime4: {
        //     num: "04",
        //     saleDate: "2月18日维护后——3月3日维护前",
        //     title: "搞机箱",
        //     saleWay: "限时促销",
        //     p: [
        //         `1、活动期间玩家可以在游戏内商城以<span style="color:red;">原价7.5折的超值优惠购买“搞机箱x100”；</span>`,
        //         `打开“搞机箱”可随机获得包括“歼星巨龙时空箱（稀有）、闪电霹雳插件Lv1、能量棒”等机友商品，更有机会获得“加农巨炮（史诗）、天空杀手（史诗）、冷酷死神（史诗）”机友时空箱！`,
        //     ],
        //     span: []
        // }
        // saleTime2: {
        //     num: "02",
        //     saleDate: "3月3日维护后——3月10日维护前",
        //     title: "稀有时装",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在商城内购买到<span style="color:red">“甜心曲奇（女）以小搏大包”，</span>
        //     打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">甜心曲奇（女）</span>一套（至少可获得3天期限）。`,
        //         `以小搏大，圆你永久梦想！。`,
        //     ],
        //     span: []
        // },
        // saleTime1: {
        //     num: "01",
        //     saleDate: "2月11日维护后——2月18日维护前",
        //     title: "III型装置",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在商城内购买到<span style="color:red">“供弹器III型以小搏大包、医疗装置III型以小搏大包”，</span>
        //     打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">供弹器III型、医疗装置III型</span>（至少可获得3天期限）。`,
        //         `以小搏大，圆你永久梦想！。`,
        //     ],
        //     span: []
        // },
        saleTime2: {
          num: "02",
          saleDate: "3月10日维护后——3月17日维护前",
          title: "神器升阶材料",
          saleWay: "限时特卖",
          p: [
            `活动期间玩家可在游戏内商城购买<span style="color:red">苍穹回响核心模块、寒霜先锋核心模块、毁灭之轮核心模块、不灭冷焰核心模块，</span>助你轻松升级你的超级神器。`,
            `活动期间玩家可在游戏内商城购买<span style="color:red">神器碎片特惠礼包，</span>助你轻松升级你的超级神器。`,
          ],
          span: []
        },
        saleTime3: {
          num: "03",
          saleDate: "3月10日维护后——3月17日维护前",
          title: "机友强化大礼包",
          saleWay: "限时特卖",
          p: [
            `活动期间玩家可在游戏内商城以原价商品8折的特惠购买<span style="color:red;">机友强化包（死亡之翼专属）、机友强化包（杀手专属）、机友强化包（巨龙专属）、机友强化包（机甲专属）、机友强化包（死神专属）、机友强化包（巨炮专属）；</span>`,
            `礼包内物品包括：特定机友专属插件LV1，机友插件随机包x1，能量棒x50；`,
            `针对特定机友而度身定制的强化礼包，使你的小伙伴拥有超强战斗力。`,
            `2、活动期间玩家可在游戏内商城以原价商品8折的特惠购买<span style="color:red;">机友强化包（闪电霹雳版）；</span>`,
            `礼包内物品包括：闪电霹雳Lv1，机友插件随机包x1，能量棒x50；`,
            `内含所有机友都可装备的超强插件“闪电霹雳”，使你的小伙伴迅速Hold住全场。`,
          ],
          span: []
        }
        // saleTime2: {
        //     num: "02",
        //     saleDate: "8月13日维护后——8月20日维护前",
        //     title: "稀有挂件",
        //     saleWay: "限时特卖",
        //     p: [
        //         `活动期间玩家可在游戏内商城购买到<span style="color:red">“龙腾涂装弹匣（传承MP5专属）以小搏大包、龙腾涂装弹匣（传承AUGA2）以小搏大包、龙腾涂装弹匣（传承M1100专属）以小搏大包”</span>。
        //         打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">龙腾涂装弹匣</span>（至少可获得3天期限）。以小博大，愿你永久梦想！`,
        //     ],
        //     span: []
        // }
        // saleTime2: {
        //   num: "02",
        //   saleDate: "4月16日维护后——4月29日维护前",
        //   title: "周年限定挂件",
        //   saleWay: "限时销售",
        //   p: [
        //     `活动期间玩家可在商城内购买到<span style="color:red">“8周年庆典涂装枪管（冻结者专属）以小搏大包”</span>
        //     打开礼包即有机会获得永久、180天、30天、7天 、3天的<span style="color:red">8周年庆典涂装枪管（冻结者专属）</span>一套（至少可获得3天期限）。`,
        //     `以小搏大，圆你永久梦想！`,
        //   ],
        //   span: []    
        // },
        // saleTime3: {
        //   num: "03",
        //   saleDate: "4月16日维护后——4月29日维护前",
        //   title: "传承专属材料",
        //   saleWay: "限时销售",
        //   p: [
        //     `活动期间玩家可在游戏内商城购买<span style="color:red;">邪能行者专属材料</span>助你轻松升级你的传承武器。`,
        //   ],
        //   span: []    
        // },
    },
    getters: {
        versTime: state => state.versTime,
        taskText: state => state.taskText,
        // taskText2: state => state.taskText2,
        bcData: state => state.bcData,
        jxData: state => state.jxData,
        freePropsData: state => state.freePropsData,
        saleTime1: state => state.saleTime1,
        saleTime2: state => state.saleTime2,
        saleTime3: state => state.saleTime3,
        // saleTime4: state => state.saleTime4,
        // saleTime5: state => state.saleTime5,
        // saleTime6: state => state.saleTime6,
        // saleTime7: state => state.saleTime7,
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js